define.alias("ember-tooltips/components/ember-tooltip", "calendar/components/ember-tooltip");